import { collection, getDocs } from 'firebase/firestore';
import { Laundry } from '../../entities';
import { Collections, db } from '../../utils/firebase.config';
import { converterOf } from '../../utils/firebase.utils';

export const useLaundries = () => {
  const laundriesCollection = collection(db, Collections.Laundries).withConverter(converterOf(Laundry));

  const fetchAll = async (): Promise<Laundry[]> => {
    const laundryDocs = await getDocs(laundriesCollection);

    return laundryDocs.docs.map((laundryDoc) => laundryDoc.data());
  };

  return { fetchAll };
};

export default useLaundries;
